import script from "./WorkingComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingComplete.vue?vue&type=script&setup=true&lang=js"

import "./WorkingComplete.vue?vue&type=style&index=0&id=40713fad&scoped=true&lang=css"

import exportComponent from "/home/xs909715/manage-sys.net/deploy/call-center-fe/production/releases/5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40713fad"]])

export default __exports__